/**
 * VERSIONE LIBRERIA 3
 */
/**
 * base class contoller model
 */
var CoreController = Class.extend({
    type: null,
    _supportedViewTypes: ['list', 'search', 'edit', 'view', 'calendar', 'csv'],
    _standarViewClass: {
        'ViewList': 'list',
        'ViewEdit': 'edit',
        'ViewSearch': 'search',
        'ViewView': 'edit',
        'ViewCsv': 'csv'
    },
    _defaultConfs: {
        'list': ListConfs,
        'edit': EditConfs,
        'search': SearchConfs,
        'calendar': CalendarConfs,
        'csv': CsvConfs
    },
    _viewCounter: 0,            // contatore per la generazione delle chiavi di view univoca

    _viewConfig: {},       // vettore contenente le view e le loro configurazioni
    /**
     configurazione tipo
     viewConfig =  {
            view : view,
            params : params,
            query_params : {},
            post_params : {},
            routeType : value,
            connected_view {
                actionName : [
                    {
                        key : value ,
                        action : value
                    }
                ]
            }
        }
     */
    constraintKey: null,
    constraintValue: null,
    modelName: null,
    options: {},
    json: {},
    afterLoadedData: {},  // funzioni da chiamare dopo il caricamento dei dati la chiave modello -> routeType -> function

    init: function () {
        this._viewCounter = 0;
        this._viewConfig = {};
    },

    /**
     * aggiunge una view al controller
     * viewClass : tipo di view, se e' di quelle standard, non serve il type
     * params :  vettore associativo opzionale
     {
         modelName : nome modello dati
         type : tipo di view definite in _standarViewClass
 *       config : configurazione view
 *       data : dati della lista,
         container: container
     }
     */
    addView: function (viewClass, params) {
        var self = this;
        log.debug('CoreController.addView', viewClass, params);
        if (!params.modelName)
            throw 'Invalid model Name';
        if (!window[viewClass])
            throw 'View Class name ' + viewClass + ' not definited!';
        var view = new window[viewClass](params.modelName);
        if (!view.type || $.inArray(view.type, self._supportedViewTypes) < 0)
            throw 'view type ' + view.type + ' not supported';


        if (params.config)
            view.setConfig(params.config);
        else {
            view.setConfig(new self._defaultConfs[view.type]());
        }
        view.setController(self);

        //view.config = params.config?params.config: new self._defaultConfs[view.type]();
        var viewKey = 'v' + self._viewCounter;
        view.keyId = viewKey;
        log.debug("constraint ", params.constraint);
        self._viewConfig[viewKey] = {
            view: view,
            params: params,
            query_params: params.config.query_params ? params.config.query_params : {},
            post_params: {},
            connected_view: {},
            routeType: params.routeType ? params.routeType : view.type,
            constraint: params.constraint ? params.constraint : ''
        };
        log.debug('addView ' + viewKey, self._viewConfig[viewKey]);
        self._viewCounter++;
        return viewKey;
    },
    removeView: function (key) {
        var self = this;
        try {
            if (!self._viewConfig[key])
                return;
            delete self._viewConfig[key].view;
            delete self._viewConfig[key];
        } catch (e) {
            log.error(e);
        }
    },
    removeAllViews: function () {
        var self = this;
        for (var k in self._viewConfig) {
            self.removeView(k);
        }
        delete self._viewConfig;
        self._viewConfig = {};
    },
    connectView: function (key, connectionView) {
        var self = this;
        var action = connectionView.action;
        if (!self._viewConfig[key]['connected_view'][action])
            self._viewConfig[key]['connected_view'][action] = [];
        self._viewConfig[key]['connected_view'][action].push(connectionView);
    },
    renderViews: function () {
        var self = this;
        for (var key in self._viewConfig) {
            self.renderView(key);
        }
    },

    renderView: function (key, callback) {
        var self = this;
        var view = self._viewConfig[key].view;
        var __render = function () {
            view.render();
            view.afterRender();
            self.connectActions(key);
            self._setValidationRules(key);
            if (callback) {
                callback();
            } else if (view.config.finalizeCallback) {
                view.config.finalizeCallback.apply(view);
            }
        }
        if (!view.data || Object.keys(view.data) == 0) {
            self._loadData(key, function (json) {
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }
                self.setJsonDataToView(key, json);
                view.afterLoadData();
                __render();
            })
        } else {
            __render();
            /*
             view.render();
             self.connectActions(key);
             self._setValidationRules(key);
             callback();
             */
        }
    },

    setJsonDataToView: function (key, json) {
        var self = this;
        var view = self._viewConfig[key].view;
        var data = {};
        $.langDefs = $.extend(true,json.translations,$.langDefs);
        // check di callback dopo il caricamento dati
        if (self.afterLoadedData[key]) {
            self.afterLoadedData[key](json);
        }
        var resultType = Routes[view.routeType].resultType;
        var protocol = new window[Utility.pascalCase(resultType + '_protocol')]();
        protocol.jsonToData(json);
        view.setData(protocol);
        /*
        if (view.type == 'list') {
            data.value = json.result.data;
            data.metadata = json.metadata;
            data.pagination = _.omit(json.result, ['data','has_errors']);
            data.resultParams = json.resultParams;
            data.validationRules = json.validationRules;
            data.backParams = json.backParams;
            data.has_errors = (json.result.has_errors == true);
        } else {
            data.value = json.result;
            data.metadata = json.metadata;
            data.pagination = null;
            data.resultParams = json.resultParams;
            data.validationRules = json.validationRules;
            data.backParams = json.backParams;
        }
        view.setData(data);
        */
    },

    setConfigToView: function (key, config) {
        var self = this;
        self.getView(key).setConfig(config);
    },

    getViewConfig: function (key) {
        return this._viewConfig[key];
    },
    /**
     * ritorna la conf per eseguire la richiesta ajax per caricare i dati
     * associati alla vista
     */
    _getAjaxConf: function (key) {
        var self = this;
        var viewConf = self._viewConfig[key];
        var aConf = {
            url: null,
            query_params: viewConf.query_params ? viewConf.query_params : {},
            method: null,
            post_params: viewConf.post_params ? viewConf.post_params : {}
        };
        console.log('_getAjaxConf', viewConf.view.routeType, 'viewConf', viewConf);
        // TODO convergere alla urlParams obbligatori
        //var urlType = viewConf.view.routeType;
        var urlType = viewConf.routeType + viewConf.constraint;
        if (viewConf.params.routeParams) {
            aConf.url = Routes.getUrlInstance(urlType, viewConf.params.routeParams);
            aConf.method = Routes[urlType].method;
            return aConf;
        }

        throw 'routeParams not found';
    },
    /**
     * ritorna la conf per eseguire la richiesta ajax per spedire i dati
     * associati alla vista
     * @param key : chiave interna univoca per prendere la configurazione della view
     */
    _sendAjaxConf: function (key) {
        var self = this;
        var viewConf = self._viewConfig[key];
        /*
         var urlValues = {
         model:viewConf.params.modelName,
         };
         */
        var urlType = viewConf.view.type;

        post_params = self._viewConfig[key].post_params ? self._viewConfig[key].post_params : {};
        if (viewConf.view.type == 'edit') {
            if (self._viewConfig[key].params.pk) {
                urlType = 'save' + viewConf.constraint;
                /*
                 var urlValues = {
                 model:self._viewConfig[key].params.modelName,
                 pk : self._viewConfig[key].params.pk
                 }
                 */
                post_params._method = 'PUT';
            } else {
                urlType = 'create' + viewConf.constraint;
                post_params._method = 'POST';
            }
        }
        log.debug('_sendAjaxConf', urlType);
        var sConf = {
            //url : Routes.getUrlInstance(urlType,urlValues),
            url: Routes.getUrlInstance(urlType, viewConf.params.routeParams),
            query_params: self._viewConfig[key].query_params ? self._viewConfig[key].query_params : {},
            method: Routes[urlType].method,
            post_params: post_params
        };
        return sConf;
    },

    /**
     * carica i dati per view di id key.
     * in caso di callback restituisce i dati ricevuti alla callback
     * @param key : id della view
     * @param callback : eventuale callback a cui ritornare i dati
     **/
    _loadData: function (key, callback) {
        var self = this;
        callback = callback ? callback : function (json) {
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }
            };
        var ajaxConf = self._getAjaxConf(key);
        //log.debug('ajaxConf',ajaxConf);
        var url = ajaxConf.url;
        if (ajaxConf.method == $.get) {
            params = ajaxConf.query_params;
        } else {
            url += "?" + ajaxConf.query_params;
            params = ajaxConf.post_params;
        }
        self._executeRequest(ajaxConf, callback)
    },

    _sendData: function (key, data, callback) {
        var self = this;
        callbackLocal = callback ? callback : function (json) {
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }
            };
        var sendConf = self._sendAjaxConf(key);

        var postData = $.extend(true, sendConf.post_params, data);
        //var postData = data;
        sendConf.post_params = postData;
        self._executeRequest(sendConf, callbackLocal);
    },
    /**
     * esegue la richiesta ajax utilizzando l'oggetto confRequest,
     * @params confRequest di tipo Routes [type]
     * @params callback chiamata di ritorno
     */
    _executeRequest: function (confRequest, callback) {
        var self = this;
        log.debug('_executeRequest', confRequest);
        // in caso di get i post params non li devo mandare altrimenti li mette in get e non va bene
        var post_params = confRequest.method == $.get ? {} : confRequest.post_params;

        //confRequest.method(confRequest.url+'?'+jQuery.param( confRequest.query_params ),confRequest.post_params,function (json) {
        confRequest.method(Facade.getUrl(confRequest.url) + '?' + jQuery.param(confRequest.query_params), post_params, function (json) {
            callback(json);
        }).fail(function (f) {
            var tmpJson = {error: 1, msg: $.getFailMessage(f)}
            callback(tmpJson);
            return
        })
    },
    /**
     * connetto le azione della view con chiave key
     * @param key : chiave univoca della view. In caso di chiave view vuota le action vengono
     * considerate globali non associate ad una view
     * @param selector : default null, eventuale selector in caso di azioni generali non associate ad una
     * view
     **/
    connectActions: function (key, selector) {
        var self = this;
        if (!key && !selector) {
            throw "Controller.connectActions invalid key and selector"
        }
        var view = self._viewConfig[key] ? self._viewConfig[key].view : null;
        var selector = view ? view.config.container : selector;
        log.info("connectionAction", key, $(selector));
        $.each($(selector).find("[data-action]"), function () {
            // controllo che non abbia la classe disabled. in quel caso non aggancio nulla

            if ($(this).hasClass('disabled'))
                return;

            var actionName = $(this).data("action");
            var pk = $(this).data("pk") ? $(this).data("pk") : null;
            var params = $(this).data("params") ? $(this).data("params") : {};
            if ($(this).is('input') || $(this).is('select')) {
                //log.info("found action [" + action + "] on " + $(this).prop('tagName'))
                $(this).unbind('change');
                $(this).change(function () {
                    pk = $(this).val();
                    self._executeAction(key, actionName, pk, params);
                    // self[action](key,pk,params);
                });
            } else {
                $(this).unbind('click');
                $(this).click(function () {
                    self._executeAction(key, actionName, pk, params);
                    //self[action](key,pk,params);
                });
            }

        });
        self._connectEvents(key);
        // intercetto eventi che possono essere azioni


    },
    _connectEvents: function (key) {
        var self = this;
        // in caso di key non valorizzata non si esegue la sezione events
        if (!key)
            return;
        var view = self._viewConfig[key].view;

        view.fireEvent = function (evt) {
            var view = self._viewConfig[key].view;
            log.debug("Controller get Event ", key, evt);

            var method = '_connectEvent'+Utility.pascalCase(evt.type);

            if (_.isFunction(self[method])) {
                self[method](evt, view);
            }


        }
    },

    _connectEventSwap: function (evt, view) {

        self = this;
        var actionParams = {
            field: evt.key,
            value: evt.params
        }
        self._executeAction(view.keyId, 'set', evt.pk, actionParams);


    },

    _connectEventMap: function (evt, view) {
        for (var k in evt.params) {
            view.setRenderData(k, evt.params[k]);
        }
    },

    _executeAction: function (key, actionName, pk, params) {
        var self = this;
        log.debug("_executeAction", key, actionName, pk, params);
        if (!key) {
            throw "Controller._executeAction key not valid";
        }
        var view = self._viewConfig[key].view;
        var custom = view.config.extra_actions ? view.config.extra_actions[actionName] : null;
        // check se la funzione e' stata definita nelle extra actions della view
        if (custom) {
            log.debug('found custom action ', custom, params);
            var validParams = params;
            if (!$.isArray(params) && !$.isPlainObject(params))
                validParams = [params];

            if (_.isFunction(custom.func)) {
                var f = view.config.extra_actions[actionName];
                f.view = view;
                return view.config.extra_actions[actionName].func.apply(f, _.values(validParams));
            }
            log.warn('custom.func not defined');
            return;
        }

        // se c'e' una funzione creata nel controller eseguo quella per prima
        if (_.isFunction(self[actionName])) {
            log.debug('found controller action ', custom, params);
            self[actionName].view = view;
            return self[actionName](key, pk, params);
        }

        throw "Controller." + actionName + " not implemented";
    },

    getView: function (key) {
        return this._viewConfig[key].view;
    },

    _setValidationRules: function (key) {

        var self = this;
        var view = self._viewConfig[key].view;
        var form = $(view.config.container).find('form');
        if (form.length == 0)
            return;
        var form_rules = {};
        for (var key in view.data.validationRules) {
            log.info("Validation rule key " + key);
            var element_rules = {};
            var rule_string = view.data.validationRules[key];
            var rules = rule_string ? rule_string.split("|") : [];
            for (var i in rules) {
                var rule = rules[i];
                try {

                    //var tmp = rule.split(":");
                    var rule_name = rule.split(":").length > 0 ? rule.split(":")[0] : rule;
                    rule_name = 'V' + rule_name;

                    if (window[rule_name]) {
                        // caso speciale
                        if (rule_name == "Vsometimes") {
                            var other_rules = _.clone(rules);
                            other_rules.splice(0, 1);

                            var r = new window[rule_name](form);
                            element_rules = $.extend(element_rules, r.get(key, other_rules));
                            break;
                        }
                        var r = new window[rule_name](form);
                        element_rules = $.extend(element_rules, r.get(key, rule));
                    } else {
                        log.warn(rule_name + " non implementata");
                    }
                    //var r = (tmp.length > 0) ? new window['V'+tmp[0]](form): new window['V'+rule](form);
                    //element_rules = $.extend(element_rules,r.get(key,rule));
                } catch (e) {
                    log.error(e);
                }
            }
            form_rules[key] = element_rules;
        }
        //console.log(form_rules);
        form.validate({
            rules: form_rules
        });
    }
});

